import React from "react"
import parse from "html-react-parser"
import { PAGE_DATA_URL_PREFIX } from "../../helpers/helper"
const CustomCategoryIntro = ({ src, title, description, buttons }) => {
  return (
    <div className="flex flex-col h-full">
      <img
        src={PAGE_DATA_URL_PREFIX + src}
        alt=""
        className="w-full max-w-full h-auto"
      />
      <div className="px-2 mt-4 flex-1 md:text-left  ">
        <p className="product-intro-title">{title}</p>
        <p className="product-intro-description mt-4 px-4 md:px-0">
          {parse(description)}
        </p>
      </div>
      <div className="px-4 mt-4 md:text-left md:px-0">
        {buttons.map((button, index) => (
          <a
            key={index}
            className="inline-block my-2 mr-5 bg-black text-white shop-button"
            href={button.href ?? ""}
            target="_blank"
            rel="noreferrer"
          >
            {button.text}
          </a>
        ))}
      </div>
    </div>
  )
}

export default CustomCategoryIntro
